<template>
  <div class="text-xs py-2" style="box-shadow: inset 0 0 20px 5px #121212;" v-if="config.ActionPopup">

    <div class="flex">
      <span class="px-3 py-0.5 text-g3 bg-g1 cursor-pointer border border-g2" :class="{
        '!border-g3 !bg-flyingeye !text-white': state == 'reseaux',
        'hover:bg-g2 hover:text-g3': state != 'reseaux'
      }" @click="ChangeState('reseaux')">
        {{ $e('Réseaux') }}
      </span>

      <span class="px-3 py-0.5 text-g3 bg-g1 cursor-pointer border border-g2" :class="{
        '!border-g3 !bg-flyingeye !text-white': state == 'autres',
        'hover:bg-g2 hover:text-g3': state != 'autres'
      }" @click="ChangeState('autres')">
        {{ $e('Autres') }}
      </span>

      <span
        class="px-3 py-0.5 text-g3 bg-g1 cursor-pointer border border-g2"
        :class="{
          '!border-g3 !bg-flyingeye !text-white': state == 'debogage',
          'hover:bg-g2 hover:text-g3': state != 'debogage'
        }"
        @click="ChangeState('debogage')"
        v-if="$root.user.can([3,4,5], 'DEVICES.DEBUG.DOCK.debug_mode_active')"
      >
        {{ $e('Débogage') }}
      </span>

      <span
        class="px-3 py-0.5 text-g3 bg-g1 cursor-pointer border border-g2"
        :class="{
          '!border-g3 !bg-flyingeye !text-white': state == 'drone',
          'hover:bg-g2 hover:text-g3': state != 'drone'
        }"
        @click="ChangeState('drone')"
        v-if="!DroneStatus && $root.user.can([3,4,5], 'DEVICES.DEBUG.DRONE.access_edit_drone')"
      >
        {{ $e('Drone') }}
      </span>

      <span class="px-3 py-0.5 text-g3 bg-g1 cursor-pointer border border-g2"
        :class="{
          '!border-g3 !bg-flyingeye !text-white': state == 'parachute',
          'hover:bg-g2 hover:text-g3': state != 'parachute'
        }"
        @click="ChangeState('parachute')"
        v-if="config?.parachute?.id && $root.user.can([3,4,5], 'DEVICES.DEBUG.FTS.access_edit_FTS')"
      >
        {{ $e('Parachute') }}
      </span>

    </div>

    <div class="flex justify-between flex-col">

      <!-- RESEAUX -->
      <div v-if="state == 'reseaux'" class="flex border border-g0 justify-around py-2">
        <!-- StatisTime -->
        <LastDockStatus :config="config" />
        <!-- Net Quality -->
        <DockNetQuality :config="config" />
        <!-- RTK -->
        <DockRTK :config="config" />
        <!-- GPS -->
        <DockGPS :config="config" />
      </div>

      <!-- AUTRES -->
      <div v-if="state == 'autres'">
        <div class="flex border border-g0 justify-around py-2">
          <!-- Storage -->
          <DockStorage :config="config" />
          <!-- DockIsCharging -->
          <DockIsCharging :config="config" />
        </div>
        <div class="flex border border-g0 justify-around py-2">
          <!-- CoverStateTexte -->
          <DockCoverStateTexte :config="config" />
          <!-- DroneInDock -->
          <DroneInDock :config="config" />
          <!-- DRC -->
          <DockDRC :config="config" />
        </div>
      </div>

      <!-- DEBOGAGE -->
      <div v-if="state == 'debogage'" class="relative border-g0 border" @click.stop.prevent="">
        <DockDebug :config="config" :smallSvg="true" />
      </div>

      <!-- DRONE -->
      <div v-if="state == 'drone'" class="relative border-g0 border" @click.stop.prevent="">
        <DroneDebug :config="config" :smallSvg="true" />
      </div>

      <!-- PARACHUTE -->
      <div v-if="state == 'parachute'" class="relative border-g0 border" @click.stop.prevent="">
        <div class="py-2">
          <Parachute_Template :config="config" :link="true" :border="true" />
        </div>
      </div>

    </div>

  </div>




</template>

<script>
import { ref, toRaw } from "vue";
import { toast } from "vue3-toastify";
import API from "@/utils/API";

import LastDockStatus from "@/partials/Device/Template/Dock/LastDockStatus.vue";
import DockStorage from "@/partials/Device/Template/Dock/DockStorage.vue";
import DockCoverStateTexte from "@/partials/Device/Template/Dock/DockCoverStateTexte.vue"
import DroneInDock from "@/partials/Device/Template/Dock/DroneInDock.vue";
import DockIsCharging from "@/partials/Device/Template/Dock/DockIsCharging.vue";
import DockRTK from "@/partials/Device/Template/Dock/DockRTK.vue";
import DockGPS from "@/partials/Device/Template/Dock/DockGPS.vue";
import DockNetQuality from "@/partials/Device/Template/Dock/DockNetQuality.vue";
import DockDRC from "@/partials/Device/Template/Dock/DockDRC.vue";
import DockDebug from "@/partials/Device/Template/Dock/DockDebug.vue";
import DroneDebug from "@/partials/Device/Template/Drone/DroneDebug.vue";

import Parachute_Template from "@/partials/Device/Template/Parachute/_Parachute_Template.vue";

export default {
  props: {
    config: Object,
  },
  setup() {
    return {
      state: ref("reseaux"),
      distanceEdit: ref(false),
      valueDistanceEdit: ref(0),
    }
  },

  components: {
    DockStorage,
    DockCoverStateTexte,
    DroneInDock,
    DockIsCharging,
    LastDockStatus,
    DockRTK,
    DockGPS,
    DockNetQuality,
    DockDRC,
    DockDebug,
    DroneDebug,

    Parachute_Template
  },

  computed: {
    DroneStatus() {
      if (this.config?.drone?.status?.LastPing != undefined) {
        return this.config.drone.status.LastPing > ENV.DEVICE_OFFLINE;
      }
      return true;
    },
  },

  methods: {
    ChangeState(state) {
      if (this.state == state) {
        this.config.ActionPopup = false
        return;
      }
      this.state = state;
    },

    /** ----------- */

  },
};
</script>
